import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RadioState } from '@app/core/states/radio.state';
import { MobCreatePlaylistComponent } from '@app/library/components/sides/mob-create-playlist/mob-create-playlist.component';
import { BacGroup } from '@app/library/models/bac.model';
import { Playlist } from '@app/library/models/playlist.model';
import { BacsState } from '@app/library/states/bacs.state';
import { PlaylistsState } from '@app/library/states/playlists.state';
import { MOBILE_DIALOG_CONFIG } from '@app/shared/constants';
import { Select } from '@ngxs/store';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'rk-bac-playlist-modal',
  templateUrl: './bac-playlist-modal.component.html',
  styleUrls: ['./bac-playlist-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacPlaylistModalComponent implements OnInit {
  @Select(RadioState.currentRadioId)
  currentRadioId$: Observable<number>;

  @Select(BacsState.bacsGroup)
  bacsGroups$: Observable<BacGroup[]>;

  @Select(PlaylistsState.playlists)
  allPlaylists$: Observable<Playlist[]>;

  @Output()
  readonly actionDone = new EventEmitter();

  playlists: Playlist[];

  searchSubject = new BehaviorSubject<string>('');

  $touched = signal(-1);

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    combineLatest([this.allPlaylists$, this.searchSubject.asObservable()])
      .pipe(filter(([p]) => !!p))
      .subscribe(([allPlaylists, val]) => {
        this.playlists = allPlaylists.filter(
          playlist => playlist.name.toLowerCase().indexOf(val.trim().toLowerCase()) > -1,
        );
        this.cdr.detectChanges();
      });
  }

  clickBox() {
    this.actionDone.emit();
  }

  onTouch(index: number) {
    setTimeout(() => {
      this.$touched.set(index);
    }, 50);
  }

  onTouchEnd() {
    this.$touched.set(-1);
  }

  search(e: string) {
    if (typeof e === 'string') {
      this.searchSubject.next(e);
    }
  }

  createPlaylist() {
    this.dialog.open(MobCreatePlaylistComponent, {
      backdropClass: 'opacity-0',
      ...MOBILE_DIALOG_CONFIG,
    });
  }
}
